/* src/pages/error/page-error.component.scss */
:host {
  display: block;
}
.message {
  margin-left: 20px;
}
/*# sourceMappingURL=page-error.component-NDBL4YO7.css.map */
